export default "__VITE_ASSET__CLPyxp3L__"